import { useNavigate } from "react-router-dom";

import ICONS from "../../../assets/Icons";

import ReimbursementTxnRequestDetail from "../../../containers/ReimbursementRequest/ReimbursementRequestDetail";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import FieldForceTxnRequestDetail from "../../../containers/FieldForceTransactions/FieldForceTxnRequestDetail";

function FieldForceReqTxnDetailsPopup({
  closePopup,
  field_force_request_id,
  type,
  RequestHeader,
  flow,
}) {
  const navigate = useNavigate();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle={RequestHeader}
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        isfullViewrequired={true}
        smallPopupHeader={"Open in full view?"}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closePopup();
          navigate(
            `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${field_force_request_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closePopup}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
        isscrollRequired={true}
      >
        <FieldForceTxnRequestDetail
          field_force_request_id={field_force_request_id}
          txn_id={field_force_request_id}
          type={type}
          closePopup={closePopup}
          flow={flow}
          isPopup
        />
      </LargePopupRedirect>
    </div>
  );
}

export default FieldForceReqTxnDetailsPopup;
